module.exports = __webpack_public_path__ + "img/a6.bf479601.png";